import { renderTableCell_unstable } from "../TableCell/renderTableCell.js";
/**
 * Render the final JSX of DataGridCell
 */ export const renderDataGridCell_unstable = (state)=>{
    return renderTableCell_unstable(state);
};
